// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./fonts.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/wave.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg {
  background-color: #faf9f6;
}

.bg--dark {
  background-color: #0c0c0c !important;
}

.text-color {
  color: aliceblue;
}

.text-color--dark {
  color: #ff7201;
}

.status {
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  margin-top: 70px;
}

.status__light {
  width: 30px;
  height: 25px;
  padding-right: 10px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}

.status__light__ring {
  position: absolute;
  width: 25px;
  height: 25px;
  animation: pulsate 2s ease-out;
  animation-iteration-count: infinite;
  opacity: 0;
  border: 3px solid #ff8a8a;
  border-radius: 30px;
}

@keyframes pulsate {
  0% {
    transform: scale(0.1, 0.1);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(1.2, 1.2);
    opacity: 0;
  }
}

.status__light__led {
  position: absolute;
  width: 13px;
  height: 13px;
  background: #ff5c5c;
  border-radius: 100%;
}

.status__message {
  padding-left: 25px;
}

.test {
  rotate: 90deg;
  top: 5%;
  right: 3.5%;
  position: absolute;
}

@media screen and (max-width: 1300px) {
  .test {
    rotate: 90deg;
    top: 5%;
    right: 5%;
    position: absolute;
  }
}

.header__chevron-down {
  position: absolute;
  width: 28px;
  height: 8px;
  opacity: 0;
  transform: scale3d(0.5, 0.5, 0.5);
  animation: move 3s ease-out infinite;
  margin-top: -70px;
}

.header__chevron-down:first-child {
  animation: move 3s ease-out 1s infinite;
}

.header__chevron-down:nth-child(2) {
  animation: move 3s ease-out 2s infinite;
}

.header__chevron-down:before,
.header__chevron-down:after {
  content: " ";
  position: absolute;
  top: 0;
  height: 50%;
  width: 51%;
  background: #f59e0b;
}

.header__chevron-down:before {
  left: 0;
  transform: skew(0deg, 30deg);
}

.header__chevron-down:after {
  right: 0;
  width: 50%;
  transform: skew(0deg, -30deg);
}

@keyframes move {
  25% {
    opacity: 1;
  }
  33% {
    opacity: 1;
    transform: translateY(30px);
  }
  67% {
    opacity: 1;
    transform: translateY(40px);
  }
  100% {
    opacity: 0;
    transform: translateY(55px) scale3d(0.5, 0.5, 0.5);
  }
}
@keyframes pulse {
  to {
    opacity: 1;
  }
}

.emoji {
  display: inline-block;
  background-size: contain;
  background-position: center;
  width: 20px;
  height: 20px;
}

.wave-hand {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  cursor: pointer;
}

.intro-name {
  font-family: "HKGroteskWide-Bold";
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/intro.css"],"names":[],"mappings":"AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EAGE,aAAa;EAGb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAGlB,aAAa;EAGb,uBAAuB;EAGvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EAEZ,8BAA8B;EAE9B,mCAAmC;EACnC,UAAU;EACV,yBAAyB;EACzB,mBAAmB;AACrB;;AAkBA;EACE;IAEE,0BAA0B;IAC1B,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IAEE,0BAA0B;IAC1B,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;IACb,OAAO;IACP,SAAS;IACT,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,UAAU;EACV,iCAAiC;EACjC,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,4BAA4B;AAC9B;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,kDAAkD;EACpD;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,2BAA2B;EAC3B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yDAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":["@import url(\"./fonts.css\");\n\n.bg {\n  background-color: #faf9f6;\n}\n\n.bg--dark {\n  background-color: #0c0c0c !important;\n}\n\n.text-color {\n  color: aliceblue;\n}\n\n.text-color--dark {\n  color: #ff7201;\n}\n\n.status {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  font-size: 1.1rem;\n  margin-top: 70px;\n}\n\n.status__light {\n  width: 30px;\n  height: 25px;\n  padding-right: 10px;\n  position: absolute;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.status__light__ring {\n  position: absolute;\n  width: 25px;\n  height: 25px;\n  -webkit-animation: pulsate 2s ease-out;\n  animation: pulsate 2s ease-out;\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  opacity: 0;\n  border: 3px solid #ff8a8a;\n  border-radius: 30px;\n}\n\n@-webkit-keyframes pulsate {\n  0% {\n    -webkit-transform: scale(0.1, 0.1);\n    transform: scale(0.1, 0.1);\n    opacity: 0;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: scale(1.2, 1.2);\n    transform: scale(1.2, 1.2);\n    opacity: 0;\n  }\n}\n\n@keyframes pulsate {\n  0% {\n    -webkit-transform: scale(0.1, 0.1);\n    transform: scale(0.1, 0.1);\n    opacity: 0;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: scale(1.2, 1.2);\n    transform: scale(1.2, 1.2);\n    opacity: 0;\n  }\n}\n\n.status__light__led {\n  position: absolute;\n  width: 13px;\n  height: 13px;\n  background: #ff5c5c;\n  border-radius: 100%;\n}\n\n.status__message {\n  padding-left: 25px;\n}\n\n.test {\n  rotate: 90deg;\n  top: 5%;\n  right: 3.5%;\n  position: absolute;\n}\n\n@media screen and (max-width: 1300px) {\n  .test {\n    rotate: 90deg;\n    top: 5%;\n    right: 5%;\n    position: absolute;\n  }\n}\n\n.header__chevron-down {\n  position: absolute;\n  width: 28px;\n  height: 8px;\n  opacity: 0;\n  transform: scale3d(0.5, 0.5, 0.5);\n  animation: move 3s ease-out infinite;\n  margin-top: -70px;\n}\n\n.header__chevron-down:first-child {\n  animation: move 3s ease-out 1s infinite;\n}\n\n.header__chevron-down:nth-child(2) {\n  animation: move 3s ease-out 2s infinite;\n}\n\n.header__chevron-down:before,\n.header__chevron-down:after {\n  content: \" \";\n  position: absolute;\n  top: 0;\n  height: 50%;\n  width: 51%;\n  background: #f59e0b;\n}\n\n.header__chevron-down:before {\n  left: 0;\n  transform: skew(0deg, 30deg);\n}\n\n.header__chevron-down:after {\n  right: 0;\n  width: 50%;\n  transform: skew(0deg, -30deg);\n}\n\n@keyframes move {\n  25% {\n    opacity: 1;\n  }\n  33% {\n    opacity: 1;\n    transform: translateY(30px);\n  }\n  67% {\n    opacity: 1;\n    transform: translateY(40px);\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(55px) scale3d(0.5, 0.5, 0.5);\n  }\n}\n@keyframes pulse {\n  to {\n    opacity: 1;\n  }\n}\n\n.emoji {\n  display: inline-block;\n  background-size: contain;\n  background-position: center;\n  width: 20px;\n  height: 20px;\n}\n\n.wave-hand {\n  background-image: url(../images/wave.png);\n  cursor: pointer;\n}\n\n.intro-name {\n  font-family: \"HKGroteskWide-Bold\";\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
